import { render, staticRenderFns } from "./ContainerOrders.vue?vue&type=template&id=390805a3"
import script from "./ContainerOrders.vue?vue&type=script&lang=js"
export * from "./ContainerOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports